import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import { ITOP_TICKET_REQUEST_USER_SATISFACTION_MAP } from '@siptel-web/common';

const ERROR_CALIFICACION = 'Debe seleccionar una calificación';

const validationSchema = yup.object({
  calificacion: yup
    .number()
    .typeError(ERROR_CALIFICACION)
    .oneOf(
      Object.keys(ITOP_TICKET_REQUEST_USER_SATISFACTION_MAP).map(Number),
      ERROR_CALIFICACION,
    )
    .required(ERROR_CALIFICACION),
  comentario: yup.string().required('El comentario no puede estar vacío'),
});

function CerrarTicketModal(props) {
  const { open, close, afterConfirm } = props;
  const { fetch: sendRequest, loading } = useFetch();

  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);

  const isRequerimiento = /^R-\d+$/.test(props?.data?.codigo);

  const cerrarTicket = React.useCallback(
    async (data) => {
      await sendRequest(
        `/tickets/${isRequerimiento ? 'requerimientos' : 'incidentes'}/${
          props?.data?.codigo
        }/cerrar`,
        { method: 'POST', data },
      );
    },
    [sendRequest, props.data.codigo, isRequerimiento],
  );

  const formik = useFormik({
    initialValues: { calificacion: null, comentario: '' },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      await cerrarTicket(values);
      resetForm();
      close();

      if (afterConfirm && typeof afterConfirm === 'function') {
        afterConfirm();
      }
    },
  });

  return (
    <Modal
      title={`Encuesta de Satisfacción: ${props?.data.codigo}`}
      content={
        <>
          <FormControl
            error={
              formik.touched.calificacion && Boolean(formik.errors.calificacion)
            }
            disabled={loading}
          >
            <FormLabel id="calificacion-row-radio-buttons-group-label">
              Calificación
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="calificacion-row-radio-buttons-group-label"
              name="calificacion"
              value={formik.values.calificacion}
              onChange={formik.handleChange}
            >
              {Object.keys(ITOP_TICKET_REQUEST_USER_SATISFACTION_MAP).map(
                (key) => (
                  <FormControlLabel
                    value={key}
                    control={<Radio />}
                    label={ITOP_TICKET_REQUEST_USER_SATISFACTION_MAP[key]}
                    key={`user-satisfaction-radio-button-${key}`}
                  />
                ),
              )}
            </RadioGroup>
            <FormHelperText>
              {formik.touched.calificacion && formik.errors.calificacion}
            </FormHelperText>
          </FormControl>
          <TextField
            margin="normal"
            fullWidth
            multiline
            rows={3}
            id="comentario"
            label="Comentarios"
            name="comentario"
            autoComplete="comentario"
            value={formik.values.comentario}
            onChange={formik.handleChange}
            disabled={loading}
            error={
              formik.touched.comentario && Boolean(formik.errors.comentario)
            }
            helperText={formik.touched.comentario && formik.errors.comentario}
          />
        </>
      }
      open={open}
      close={onCloseModal}
      onConfirm={formik.handleSubmit}
      loading={loading}
      disabled={loading}
      confirmButtonText="Guardar"
      cancelButtonText="Cerrar"
    />
  );
}

export default CerrarTicketModal;
